module.exports = __webpack_public_path__ + "img/70.334bec31.jpg";